import { Switch as CustomSwitch } from '@mui/material';
import styled from 'styled-components';

export const Switch = styled(CustomSwitch)``;
